import React from "react";
import Saves_Money from '../../template/images/Saves Money.png';
import CourseRequest from '../../template/images/CourseRequest.png';
import Get_Certified from '../../template/images/Get Certified.png';
import Curated_by_Experts  from '../../template/images/Curated by Experts.png';
import './home.css';
import { useNavigate, useParams } from 'react-router-dom';


const CourseRequestItems = (props) => {
    const { uspTitle, description } = props;
        const navigate = useNavigate();
    

    const navigateTo = () => {
        navigate('/CourseRequestForm')
      };

    return (
        <React.Fragment>

            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="courseRequest_inner">
                        <div className="courseRequest">
                            <h2 className="courseRequest_title">Can't Find What You're Looking For?</h2>
                            <p className="courseRequest_description">Is there a specific course you need that’s not currently available? Let us know, and we’ll work on adding it to our platform.</p>
                            <div className="hero_button_main">
                                <button className="hero_Explore_btn" 
                                onClick={navigateTo}
                                >Request a Course</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div className="courseRequest_inner">
                        <div className="courseRequest_image_main">
                            <img src={CourseRequest} className="courseRequest_image img-fluid"></img>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}

export default CourseRequestItems;
